<template>
  <div class="p-15" v-if="document">
    <el-card header="基本信息">
      <el-row :gutter="20">
        <el-col :span="6">订单编号：{{ document.sn }}</el-col>
        <el-col :span="6">下单用户：{{ document.nickname }}({{ document.phoneNumber }})</el-col>
        <el-col :span="6">下单时间：{{ document.createdAt }}</el-col>
      </el-row>
      <el-row :gutter="20" class="m-t-10">
        <el-col :span="6">订单来源：{{ ORDER_SOURCE.filterValue(document.source) }}</el-col>
        <el-col :span="6">积分消耗：{{ document.creditTotal }}</el-col>
        <el-col :span="6">订单状态 ：{{ document.shippingStatus === ORDER_STATUS.unshipped ? "待发货" : document.shippingStatus === ORDER_STATUS.shipped ? "待收货" : "已完成" }}</el-col>
      </el-row>
      <el-row :gutter="20" class="m-t-10">
        <el-col :span="6">充值账户：{{ document.account || document.phoneNumber || '-' }}</el-col>
        <el-col v-if="document.type === ORDER_TYPE.entity && document.shippingStatus !== ORDER_STATUS.unshipped" :span="6">快递公司：{{ document.expressName || '-' }}</el-col>
        <el-col v-if="document.type === ORDER_TYPE.entity && document.shippingStatus !== ORDER_STATUS.unshipped" :span="6">快递单号：{{ document.expressNumber || '-' }}</el-col>
      </el-row>
    </el-card>
    <el-card class="m-t-20" header="兑换礼品">
      <el-table :data="table_data">
        <el-table-column label="礼品名称/规格">
          <template slot-scope="{row}">
            <div class="flex">
              <el-image :src="row.photoUrls[0]" style="width: 50px;height: 50px"></el-image>
              <div class="m-l-5">
                <div>{{ row.title }}</div>
                <div>
                  <span>{{ GIFT_TYPE.filterValue(row.type) }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="消耗积分" width="120px" align="center">
          <template slot-scope="{row}">
            {{ document.creditTotal }}
          </template>
        </el-table-column>
        <el-table-column label="数量" width="120px" align="center">
          <template slot-scope="{row}">
            {{ document.quantity }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card header="收货人信息" class="m-t-20">
      <el-row :gutter="20">
        <el-col :span="6">收货人：{{ document.consignee || '-' }} | {{ document.phoneNumber || '-'}}</el-col>
      </el-row>
      <el-row :gutter="20" class="m-t-10">
        <el-col :span="6">收货地址： {{ document.province }}{{ document.city }}{{ document.county }}{{ document.address }}</el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {getEntity} from "@/api/order";
import {ORDER_SOURCE, ORDER_STATUS, ORDER_TYPE} from "@/enums/order";
import {GIFT_TYPE} from "@/enums/gift";

export default {
  name: "fictitious-detail",
  data() {
    return {
      document: undefined,
      table_data: [],

      ORDER_SOURCE,
      ORDER_STATUS,
      GIFT_TYPE,
      ORDER_TYPE
    }
  },
  methods: {},
  async mounted() {
    const {id} = this.$route.query

    if (id) {
      const {document} = await getEntity(id)
      this.document = document

      this.table_data = document.gift ? [document.gift] : []
    }
  }
}
</script>

<style scoped>

</style>
